// import React, { useState } from 'react';
// import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';



// const Header = () => {
//   const [isNavOpen, setIsNavOpen] = useState(false);
//   const [isSearchOpen] = useState(false);


//   const toggleNav = () => {
//     setIsNavOpen(!isNavOpen);
//   };


//   return (
//     <header className>
//       {/* Header Top */}
//       <div className="header-top bgg-darkk">
//         <div className="container">
//           <div className="row justify-content-center justify-content-xl-between align-items-center">
//             <div className="col-auto">
//               <div className="header-top-contact">
//                 <ul className='anchor d-md-flex'>
//                   <li className='px-md-5 fw-bold'>
//                     <a className='text-white' href="tel:+919822136667">
//                       <i className="fas fa-phone-volume text-white"></i> +91 9822136667
//                     </a>
//                   </li>
//                    <li className='px-md-5 fw-bold'>
//                     <a className='text-white' href="tel:+917350959600">
//                       <i className="fas fa-phone-volume text-white"></i> +91 7350959600
//                     </a>
//                   </li>
//                    <li className='px-md-5 fw-bold'>
//                     <a className='text-white' href="tel:+917507705135">
//                       <i className="fas fa-phone-volume text-white"></i> +91 7507705135
//                     </a>
//                   </li>
//                   <li>
//                     <a className='text-white' href="mailto:sanjay.nalawade@punecorporatecars.com">
//                       <i className="far fa-envelope text-white"></i>
//                       <span className='text-white fw-bold'> sanjay.nalawade@punecorporatecars.com</span>
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>

//       {/* Main Navigation */}
//       <div className="main-navigation">
//         <Navbar expand="lg">
//           <Container>
//             <img src="/images/9.jpg" className='logoo' alt="logo" />
//             <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
//               <i className="fas fa-bars darkcolor"></i> 
//             </Navbar.Toggle>

//             <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
//               <Nav className="mx-auto">
//                 <Nav.Link href="/" className='fw-bold nav-item'>Home</Nav.Link>
//                 <NavDropdown title="About Us" id="about-us-dropdown" className='fw-bold'>
//                   <NavDropdown.Item href="/about" className='fw-bold nav-item'>About Us</NavDropdown.Item>
//                   <NavDropdown.Item href="/term-condition" className='fw-bold nav-item'>Term & Condition</NavDropdown.Item>
//                   <NavDropdown.Item href="/privacy-policy" className='fw-bold '>Privacy Policy</NavDropdown.Item>
                 
//                 </NavDropdown>
//                 <Nav.Link href="/services" className='fw-bold nav-item'>Services</Nav.Link>
//                 <Nav.Link href="/our-fleet" className='fw-bold nav-item'>Our Fleet</Nav.Link>
//                 <Nav.Link href="/packages" className='fw-bold nav-item'>Packages</Nav.Link>
//                 <Nav.Link href="/booking" className='fw-bold nav-item'>Online Booking</Nav.Link>
//                 <Nav.Link href="/gallery" className='fw-bold nav-item'>Gallery</Nav.Link>
//                 <NavDropdown title="Contact Us" id="contact-dropdown" className='fw-bold'>
//                   <NavDropdown.Item href="/contact-us" className='fw-bold nav-item'>Contact Us</NavDropdown.Item>
//                   <NavDropdown.Item href="/enquiry" className='fw-bold'>Enquiry</NavDropdown.Item>
//                 </NavDropdown>
//               </Nav>
           
//             </Navbar.Collapse>
            
//           </Container>
         
//         </Navbar>
//       </div>

//       {/* Search Area */}
//       {isSearchOpen && (
//         <div className="search-area">
//           <form action="#">
//             <div className="form-group">
//               <input type="text" className="form-control" placeholder="Type Keyword..." />
//               <button type="submit" className="search-icon-btn">
//                 <i className="far fa-search"></i>
//               </button>
//             </div>
//           </form>
//         </div>
//       )}
//     </header>
//   );
// };

// export default Header;



// import React, { useState } from "react";
// import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
// import "@fortawesome/fontawesome-free/css/all.min.css";

// const Header = () => {
//   const [isNavOpen, setIsNavOpen] = useState(false);

//   const toggleNav = () => {
//     setIsNavOpen(!isNavOpen);
//   };

//   return (
//     <header className="header-wrapper">

//       {/* ================= TOP BAR ================= */}
//       <div className="header-top-custom">
//         <Container>
//           <div className="d-flex flex-wrap justify-content-center justify-content-md-between align-items-center text-white">

//             <div className="d-flex flex-wrap align-items-center gap-4 top-contact">

//               <a href="tel:+919822136667" className="top-link">
//                 <i className="fas fa-phone-alt"></i> +91 9822136667
//               </a>

//               <a href="tel:+917350959600" className="top-link">
//                 <i className="fas fa-phone-alt"></i> +91 7350959600
//               </a>

//               <a href="tel:+917507705135" className="top-link">
//                 <i className="fas fa-phone-alt"></i> +91 7507705135
//               </a>

//               <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="top-link">
//                 <i className="far fa-envelope"></i> sanjay.nalawade@punecorporatecars.com
//               </a>

//             </div>
//           </div>
//         </Container>
//       </div>

//       {/* ================= MAIN NAVIGATION ================= */}
//       <Navbar expand="lg" className="main-nav-custom" sticky="top">
//         <Container>

//           {/* LOGO */}
//           <Navbar.Brand href="/">
//             <img src="/images/9.jpg" alt="Pune Corporate Cars India Private Limited" className="nav-logo" />
//           </Navbar.Brand>

//           <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
//             <i className="fas fa-bars bar-icon"></i>
//           </Navbar.Toggle>

//           <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
//             <Nav className="ms-auto align-items-lg-center nav-items-custom">

//               <Nav.Link href="/" className="nav-link-custom">Home</Nav.Link>

//               <NavDropdown
//                 title="About Us"
//                 id="about-dropdown"
//                 className="nav-link-custom"
//               >
//                 <NavDropdown.Item href="/about">About Us</NavDropdown.Item>
//                 <NavDropdown.Item href="/term-condition">Terms & Conditions</NavDropdown.Item>
//                 <NavDropdown.Item href="/privacy-policy">Privacy Policy</NavDropdown.Item>
//               </NavDropdown>

//               <Nav.Link href="/services" className="nav-link-custom">Services</Nav.Link>
//               <Nav.Link href="/our-fleet" className="nav-link-custom">Our Fleet</Nav.Link>
//               <Nav.Link href="/packages" className="nav-link-custom">Packages</Nav.Link>
//               <Nav.Link href="/booking" className="nav-link-custom">Online Booking</Nav.Link>
//               <Nav.Link href="/gallery" className="nav-link-custom">Gallery</Nav.Link>

//               <NavDropdown
//                 title="Contact Us"
//                 id="contact-dropdown"
//                 className="nav-link-custom"
//               >
//                 <NavDropdown.Item href="/contact-us">Contact Us</NavDropdown.Item>
//                 <NavDropdown.Item href="/enquiry">Enquiry</NavDropdown.Item>
//               </NavDropdown>

//             </Nav>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>

//     </header>
//   );
// };

// export default Header;
























import React, { useState } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const [showBooking, setShowBooking] = useState(false);

  // const toggleNav = () => setIsNavOpen(!isNavOpen);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };


const handleSubmit = (e) => {
  e.preventDefault();

  const form = e.target;

  const subject = "New Ride Enquiry - Pune Corporate Cars";

  const body = `
New Booking Enquiry

Name: ${form[0].value} ${form[1].value}
Mobile: ${form[2].value}
Email: ${form[3].value}

From City: ${form[4].value}
To City: ${form[5].value}
Pickup Location: ${form[6].value}
Vehicle: ${form[7].value}

Pickup Time: ${form[8].value}
Pickup Date: ${form[9].value}
Return Date: ${form[10].value}

--
Pune Corporate Cars India Pvt. Ltd.
`;

  window.location.href =
    `mailto:sanjay.nalawade@punecorporatecars.com` +
    `?subject=${encodeURIComponent(subject)}` +
    `&body=${encodeURIComponent(body)}`;
};



  return (
    <header className="pcc-header">

      {/* ======== TOP CONTACT BAR ======== */}
     


<div className="pcc-topbar border p-0 py-2">
  <Container>
    <div className="pcc-top-content">

      <span className="welcome-text">
        <i className="fas fa-car-side"></i> Welcome to Pune Corporate Cars India Pvt. Ltd.
      </span>

      <span className="helpdesk-text">
        <i className="fas fa-headset"></i> Help Desk 24×7: 9822943334 / 9405644855
      </span>

      <a href="mailto:sanjay.nalawade@punecorporatecars.com">
        <i className="far fa-envelope"></i> sanjay.nalawade@punecorporatecars.com
      </a>
        <span className="sales-text">
        <i className="fas fa-briefcase"></i>
        <span> Corporate Sales: 9822136667</span>
      </span>

   

    </div>
  </Container>
</div>




      {/* ======== MAIN NAVIGATION ======== */}
      <Navbar expand="lg" className="pcc-navbar" sticky="top">
        <Container>

          {/* LOGO */}
          <Navbar.Brand href="/">
            <img
              src="/images/9.jpg"
              alt="Pune Corporate Cars"
              className="pcc-logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
            <i className="fas fa-bars pcc-menu-icon"></i>
          </Navbar.Toggle>

          <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
            <Nav className="ms-auto pcc-nav-links">

              <Nav.Link href="/">Home</Nav.Link>

              <NavDropdown title="About Us" id="about-dropdown">
                <NavDropdown.Item href="/about">About Us</NavDropdown.Item>
                <NavDropdown.Item href="/term-condition">Terms & Conditions</NavDropdown.Item>
                <NavDropdown.Item href="/privacy-policy">Privacy Policy</NavDropdown.Item>
                <NavDropdown.Item href="/gallery">Gallery</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
  title="Services"
  id="services-dropdown"
  className="pcc-services-dropdown"
>
  <div className="pcc-mega-menu">
    <NavDropdown.Item href="/corporate-car-rental">
      Corporate Car Rental
    </NavDropdown.Item>

    <NavDropdown.Item href="/employee-transport">
      Employee Transport Solutions
    </NavDropdown.Item>

    <NavDropdown.Item href="/car-rental">
      Car Rental Services
    </NavDropdown.Item>


    <NavDropdown.Item href="/conference-delegation">
      Conferences & Delegations
    </NavDropdown.Item>

    <NavDropdown.Item href="/event-transportation">
      Event Transportation
    </NavDropdown.Item>

    <NavDropdown.Item href="/hotel-travel-desk">
      Hotel Travel Desk
    </NavDropdown.Item>

    <NavDropdown.Item href="/wedding-car-rental">
      Wedding Car Rental
    </NavDropdown.Item>


    <NavDropdown.Item href="/travel-partners">
      Travel Partners Program
    </NavDropdown.Item>

    
    <NavDropdown.Item href="/pan-india">
      Pan India Car rental services
    </NavDropdown.Item>

    
    <NavDropdown.Item href="/monthly-term-rentals">
      Monthly/Long Term Rentals
    </NavDropdown.Item>
  </div>
</NavDropdown>


              <NavDropdown title="Rides" id="rides-dropdown">
  <NavDropdown.Item href="/sedan">Sedan</NavDropdown.Item>
  <NavDropdown.Item href="/muv">MUV</NavDropdown.Item>
  <NavDropdown.Item href="/premium">Premium</NavDropdown.Item>
  <NavDropdown.Item href="/luxury">Luxury</NavDropdown.Item>
  <NavDropdown.Item href="/buses">Buses</NavDropdown.Item>
</NavDropdown>


              {/* <Nav.Link href="/gallery">Gallery</Nav.Link> */}
              <Nav.Link href="/Blog">Blog</Nav.Link>
              <Nav.Link href="/Our-Network">Our&nbsp;Network</Nav.Link>
     <NavDropdown title="Contact&nbsp;Us" id="rides-dropdown">
  <NavDropdown.Item href="/contact-us">Contact&nbsp;Us</NavDropdown.Item>
  <NavDropdown.Item href="/enquiry">Enquiry</NavDropdown.Item>
  <NavDropdown.Item href="/Career">Career</NavDropdown.Item>
</NavDropdown>


              {/* <Nav.Link href="/Career">Career</Nav.Link>
              <Nav.Link href="/enquiry">Enquiry</Nav.Link>
              <Nav.Link href="/contact-us">Contact&nbsp;Us</Nav.Link> */}

          {/* ===== Header Action Buttons ===== */}
{/* ===== Header CTA Buttons ===== */}
<div className="pcc-header-buttons">
  <button
    type="button"
    className="pcc-btn pcc-btn-book"
    onClick={() => setShowBooking(true)}
  >
    Book Ride
  </button>

  <a href="/pay-now" className="pcc-btn pcc-btn-pay">
    Pay Now
  </a>
</div>





            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>



      {/* ================= BOOK RIDE MODAL ================= */}
      {showBooking && (
        <div className="booking-overlay">
          <div className="booking-modal booking-modal-responsive">


            <button
              className="close-btn"
              onClick={() => setShowBooking(false)}
            >
              ×
            </button>

            <h5>
              <i className="fas fa-car"></i> Book a Ride
            </h5>
            <p className="text-muted small">
              Economical | Efficient | Dependable
            </p>

           <form onSubmit={handleSubmit}>

              <div className="row g-2">

                <div className="col-md-6">
                  <input className="form-control" placeholder="Guest Name" />
                </div>
                <div className="col-md-6">
                  <input className="form-control" placeholder="Surname" />
                </div>

                <div className="col-md-6">
                  <input className="form-control" placeholder="Mobile Number" />
                </div>
                <div className="col-md-6">
                  <input className="form-control" placeholder="Email ID" />
                </div>

                <div className="col-md-6">
                  <input className="form-control" placeholder="From City" />
                </div>
                <div className="col-md-6">
                  <input className="form-control" placeholder="To City" />
                </div>

                <div className="col-md-6">
                  <input className="form-control" placeholder="Pickup Location" />
                </div>
                <div className="col-md-6">
                  <select className="form-control">
                    <option>Select Vehicle</option>
                    <option>Sedan</option>
                    <option>MUV</option>
                    <option>Premium</option>
                    <option>Luxury</option>
                    <option>Bus</option>
                  </select>
                </div>

                <div className="col-md-4">
                  <input type="time" className="form-control" />
                </div>
                <div className="col-md-4">
                  <input type="date" className="form-control" />
                </div>
                <div className="col-md-4">
                  <input type="date" className="form-control" />
                </div>

              </div>

              <button className="btn btn-danger w-100 mt-3">
                Submit Enquiry
              </button>
            </form>

          </div>
        </div>
      )}

    </header>
  );
};

export default Header;